<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.53001 13.7656C14.9264 10.9988 13.7125 23.1016 3 24C7.71257 23.4161 13.5033 16.6592 9.53001 13.7656ZM13.5938 10.0491C19.7298 6.61228 18.6516 22.1303 7.2504 23.6198C11.9183 22.9154 17.5289 13.9556 13.5938 10.0491ZM18.4742 6.89812C24.8464 2.90373 23.7274 20.9387 11.8872 22.6694C17.0643 21.3616 22.5616 11.4379 18.4742 6.89812ZM8.89271 9.55372C9.79922 9.55372 10.5348 10.277 10.5348 11.1691C10.5348 12.0616 9.79922 12.7851 8.89271 12.7851C7.9862 12.7851 7.2504 12.0616 7.2504 11.1691C7.2504 10.277 7.9862 9.55372 8.89271 9.55372ZM12.9496 5.3719C13.9631 5.3719 14.7852 6.18095 14.7852 7.17791C14.7852 8.17511 13.9631 8.98347 12.9496 8.98347C11.9365 8.98347 11.1144 8.17511 11.1144 7.17791C11.1144 6.18095 11.9365 5.3719 12.9496 5.3719ZM17.5862 1C18.8133 1 19.8084 1.97879 19.8084 3.18592C19.8084 4.39311 18.8133 5.3719 17.5862 5.3719C16.3598 5.3719 15.3648 4.39311 15.3648 3.18592C15.3648 1.97879 16.3598 1 17.5862 1Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgSDBPNewsFeed',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>